import { render, staticRenderFns } from "./mass-notification.vue?vue&type=template&id=32537db1&"
import script from "./mass-notification.vue?vue&type=script&lang=js&"
export * from "./mass-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports